/**
 * Creator for async action types.
 *
 * Generates an object containing action type constants and helper functions
 * for managing actions related to asynchronous operations in Redux.
 *
 * @param {string} name - Base name for the action type (e.g., "FETCH_DATA", "UPDATE_PROFILE").
 *                          Should follow the format <NOUN>_<VERB>.
 * @param {string} identifier - Full path or identifier for the reducer slice (e.g., "Dashboard/Home/ActivityLog").
 * @returns {{
 *  INITIATE: string,
 *  SUCCESS: string,
 *  ERROR: string,
 *  CANCEL: string,
 *  initiate: (payload?: any) => { type: string, payload },
 *  cancel: () => { type: string },
 *  onSuccess: (payload?: any) => { type: string, payload },
 *  onError: (error: any) => { type: string, error }
 * }} - An object containing action type constants and action creator helpers.
 */

export const ASYNC_ERROR_POSTFIX = 'CATCH_ERROR'

export const createAsyncTypes = (actionName, actionIdentifier) => {
  const INITIATE = `${actionIdentifier}/${actionName}`
  const SUCCESS = `${actionIdentifier}/${actionName}_SUCCESS`
  const ERROR = `${actionIdentifier}/${actionName}_${ASYNC_ERROR_POSTFIX}`
  const CANCEL = `${actionIdentifier}/${actionName}_CANCEL`

  const createAction = (type, payload = null, error = null) => ({ type, payload, error })

  return {
    INITIATE,
    SUCCESS,
    ERROR,
    CANCEL,

    initiate: (payload) => createAction(INITIATE, payload),
    cancel: () => createAction(CANCEL),
    onSuccess: (payload) => createAction(SUCCESS, payload),
    onError: (error) => createAction(ERROR, null, error),
  }
}
